<template>
<div class="macarons-graph--counter" :style="containerStyle" >
  <div ref="counter" :style="style" >
    {{ formatter(animated) }}
  </div>
</span>
</div>
</template>

<script>
import Animate from './animate'

export default {
  props: {
    data: {
      required: true,
      type: Number
    },
    formatter: {
      type: Function,
      default: v => v.toFixed(0)
    },
    alwaysRound: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      animated: this.data,
      animate: new Animate(),
      style: {
        'font-size': null
      }
    }
  },
  computed: {
    containerStyle () {
      const style = {}
      if (this.color) {
        style.color = this.color
      }
      if (this.backgroundColor) {
        style['background-color'] = this.backgroundColor
      }
      return style
    }
  },
  watch: {
    alwaysRound: {
      immediate: true,
      handler (val) {
        this.style.width = this.alwaysRound ? '80px' : null
      }
    },
    data: {
      immediate: true,
      handler (to, from) {
        this.style['font-size'] = null
        this.animate
          .data(from || 0, to)
          .run(this.nextStep.bind(this), { promise: true })
          .then(() => this.$nextTick(() => this.shrink()))
      }
    }
  },
  methods: {
    shrink () {
      const el = this.$refs.counter
      if (this.alwaysRound && el.clientWidth < el.scrollWidth) {
        const size = window
              .getComputedStyle(el, null)
              .getPropertyValue('font-size')
              .slice(0, -2)
        this.style['font-size'] = (parseFloat(size) - 0.1) + 'px'
        this.$nextTick(() => this.shrink())
      }
    },
    nextStep (value) {
      this.animated = value
    }
  }
}
</script>

<style scoped>
.macarons-graph--counter {
    white-space: nowrap;
    height: 80px;
    line-height: 80px;
    width: 80px;
    color: #fff;
    border-radius: 100px;
    display: flex;
    margin: 0 auto;
    font-weight: bold;
    font-size: 20px;
}
.macarons-graph--counter div {
    margin: 0 10px;
    max-width: 60px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/Counter.vue